var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "leading-icon",
    clipPath: "url(#editIcon)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 16.8538V19.5556C4 19.8045 4.19553 20 4.44438 20H7.14623C7.26177 20 7.37731 19.9556 7.4573 19.8667L17.1626 10.1703L13.8297 6.83738L4.13331 16.5338C4.04444 16.6227 4 16.7293 4 16.8538ZM19.74 7.59283C20.0867 7.24622 20.0867 6.68629 19.74 6.33968L17.6603 4.25996C17.3137 3.91335 16.7538 3.91335 16.4072 4.25996L14.7807 5.8864L18.1136 9.21928L19.74 7.59283Z",
    fill: props.color
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "editIcon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c7212ad88ea85d44cefaf80aeeeab8ed.svg";
export { ForwardRef as ReactComponent };